// removed by extract-text-webpack-plugin
module.exports = {"ToggleButton":"ToggleButton--2c09H","default":"default--2s_Jj","Selected":"Selected--30FGe","on":"on--2QU5d","off":"off--34S5J","disabled":"disabled--1K75H"};